import styled from 'styled-components';
import COLOR from '../../../utils/colors.constants';

const Label = styled.label`
  margin: 5px 2px;
  font-size: 1rem;
  font-weight: 600;
  color: ${COLOR.AZUL};
`;

export default Label;
